export default {
  en: {
    department: 'department | departments',
    agent: 'agent | agents',
    admin: 'admin | admins',
    supervisor: 'supervisor | supervisors',
    superadmin: 'super admin | super admins',
    root: 'master account | master accounts',
    subscription: 'subscription | subscriptions',
    business: 'business | businesses',
    integration: 'integration | integrations',
    developer: 'developer | webhooks',
    channel: 'channel | channels',
    user: 'user | accounts',
    metric: 'metric | metrics',
    privilege: 'privileges | priveleges',
    call: 'call || calls',
    web: 'web',
    kiosk: 'kiosk || kiosks',
    account: 'cuenta',
  },
  es: {
    department: 'departamento | departamentos',
    agent: 'agente | agentes',
    admin: 'administrador | administradores',
    supervisor: 'supervisor | supervisores',
    superadmin: 'super admininistrador | super adminstradores',
    root: 'cuenta maestra | cuentas maestras',
    subscription: 'suscripción | suscripciones',
    business: 'empresa | empresas',
    integration: 'integración | integraciones',
    developer: 'desarrollador | desarrolladores',
    channel: 'canal | canales',
    user: 'usuario | usuarios',
    metric: 'métrica | métricas',
    privilege: 'privilegio | privilegios',
    call: 'llamada || llamadas',
    web: 'web',
    kiosk: 'quiosco || quioscos',
    account: 'cuenta',
  },
};
